module.exports = __webpack_public_path__ + "img/icon-book-open.72b99ef8.svg";